var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaintraLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1017,
    height: 390,
    viewBox: "0 0 1017 390",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6110_85462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.285 80.8195L470.363 88.3043C463.717 81.5392 454.4 77.5089 444.865 77.5089C425.435 77.5089 409.834 92.4785 409.834 111.334C409.834 130.19 425.435 145.16 444.865 145.16C454.327 145.16 463.573 141.201 470.363 134.868L476.358 141.633C467.834 149.622 456.278 154.876 444.36 154.876C419.513 154.876 399.794 135.66 399.794 111.334C399.794 87.0088 419.729 68.2969 444.721 68.2969C456.567 68.2969 467.979 73.0468 476.213 80.8195H476.285Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.277 132.638L491.67 154.373H481.197L519.84 68.5859H530.025L568.523 154.373H557.833L548.227 132.638H501.205H501.277ZM524.68 79.6692L505.466 123.21H544.109L524.68 79.6692Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.175 154.373V68.5859H591.998V154.373H582.175Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.613 154.373L627.969 85.4987V154.373H618.145V68.5859H628.33L680.046 137.604V68.5859H689.797V154.373H679.685H679.613Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.164 78.0139V154.373H732.341V78.0139H704.316V68.5859H770.406V78.0139H742.237H742.164Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.134 127.026C821.256 127.17 819.306 127.242 817.356 127.242H794.459V154.303H784.636V68.5156H817.356C838.881 68.5156 851.304 79.0951 851.304 97.3032C851.304 111.553 844.442 121.053 832.019 125.155L852.171 154.303H840.975L823.134 126.954V127.026ZM817.356 117.814C832.958 117.814 841.842 110.977 841.842 97.5911C841.842 84.2049 832.958 77.9436 817.356 77.9436H794.459V117.814H817.356Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.135 132.638L871.529 154.373H861.055L899.698 68.5859H909.883L948.381 154.373H937.691L928.085 132.638H881.063H881.135ZM904.538 79.6692L885.324 123.21H923.968L904.538 79.6692Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.969 196.327L463.501 215.83C458.3 208.849 450.571 204.315 443.926 204.315C433.597 204.315 426.085 212.52 426.085 223.963C426.085 235.406 433.597 243.826 443.926 243.826C450.066 243.826 457.794 240.012 463.501 234.038L479.969 251.599C470.362 262.034 455.7 268.799 442.409 268.799C415.973 268.799 396.76 250.015 396.76 224.394C396.76 198.773 416.479 180.781 443.493 180.781C456.639 180.781 471.085 186.899 479.897 196.47L479.969 196.327Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.952 224.468C574.952 249.945 555.016 268.729 527.569 268.729C500.121 268.729 480.186 250.089 480.186 224.468C480.186 198.847 500.121 180.711 527.569 180.711C555.016 180.711 574.952 199.135 574.952 224.468ZM509.511 224.54C509.511 236.343 518.107 244.979 528.002 244.979C537.898 244.979 545.698 236.271 545.698 224.54C545.698 212.809 537.825 204.317 528.002 204.317C518.179 204.317 509.511 212.809 509.511 224.54Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.92 267.509L608.972 223.608V267.509H583.042V181.578H606.877L640.97 225.695V181.578H666.828V267.509H642.992H642.92Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.058 267.509L705.11 223.608V267.509H679.18V181.578H703.016L737.108 225.695V181.578H762.967V267.509H739.131H739.058Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.849 203.097V213.676H844.226V235.267H803.849V245.918H849.354V267.509H775.246V181.578H848.198V203.169H803.777L803.849 203.097Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.064 196.327L922.595 215.83C917.395 208.849 909.666 204.315 903.021 204.315C892.692 204.315 885.18 212.52 885.18 223.963C885.18 235.406 892.692 243.826 903.021 243.826C909.16 243.826 916.961 240.012 922.595 234.038L939.064 251.599C929.457 262.034 914.794 268.799 901.504 268.799C875.068 268.799 855.854 250.015 855.854 224.394C855.854 198.773 875.573 180.781 902.587 180.781C915.733 180.781 930.179 186.899 938.991 196.47L939.064 196.327Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.369 203.962V267.439H963.839V203.962H939.353V181.508H1017V203.962H992.369Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.627 316.012V298.164H399.649V316.012H397.627Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.923 316.012L407.161 301.691V316.012H405.139V298.164H407.233L417.996 312.486V298.164H420.018V316.012H417.923Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.22 316.012L427.458 301.691V316.012H425.435V298.164H427.53L438.292 312.486V298.164H440.315V316.012H438.22Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.851 307.09C462.851 312.128 458.734 316.086 453.461 316.086C448.188 316.086 444.071 312.056 444.071 307.09C444.071 302.124 448.188 298.094 453.461 298.094C458.734 298.094 462.851 302.052 462.851 307.09ZM446.165 307.09C446.165 311.048 449.488 314.143 453.461 314.143C457.433 314.143 460.756 310.976 460.756 307.09C460.756 303.204 457.506 300.037 453.461 300.037C449.416 300.037 446.165 303.132 446.165 307.09Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.085 316.012L463.862 298.164H466.029L472.168 313.637L478.38 298.164H480.547L473.252 316.012H471.157H471.085Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.797 311.549L481.775 316.083H479.608L487.625 298.234H489.72L497.738 316.083H495.499L493.476 311.549H483.725H483.797ZM488.637 300.537L484.664 309.605H492.682L488.637 300.537Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.412 316.012L502.649 301.691V316.012H500.627V298.164H502.722L513.484 312.486V298.164H515.506V316.012H513.412Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.219 298.164C533.419 298.164 537.392 301.978 537.392 307.088C537.392 312.198 533.347 316.012 528.146 316.012H520.996V298.164H528.219ZM523.018 314.069H528.219C532.191 314.069 535.297 311.118 535.297 307.088C535.297 303.058 532.119 300.107 528.146 300.107H523.018V314.069Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.761 307.09C557.761 312.128 553.644 316.086 548.371 316.086C543.098 316.086 538.981 312.056 538.981 307.09C538.981 302.124 543.098 298.094 548.371 298.094C553.644 298.094 557.761 302.052 557.761 307.09ZM541.076 307.09C541.076 311.048 544.398 314.143 548.371 314.143C552.343 314.143 555.666 310.976 555.666 307.09C555.666 303.204 552.416 300.037 548.371 300.037C544.326 300.037 541.076 303.132 541.076 307.09Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.546 300.179V306.009H579.574V307.952H570.546V314.069H580.947V316.012H568.451V298.164H580.586V300.107H570.473L570.546 300.179Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.993 316.012L587.231 301.691V316.012H585.208V298.164H587.303L598.065 312.486V298.164H600.088V316.012H597.993Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.63 307.09C629.63 312.128 625.513 316.086 620.24 316.086C614.967 316.086 610.85 312.056 610.85 307.09C610.85 302.124 614.967 298.094 620.24 298.094C625.513 298.094 629.63 302.052 629.63 307.09ZM612.945 307.09C612.945 311.048 616.267 314.143 620.24 314.143C624.213 314.143 627.535 310.976 627.535 307.09C627.535 303.204 624.285 300.037 620.24 300.037C616.195 300.037 612.945 303.132 612.945 307.09Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.103 298.166C644.509 298.166 647.109 300.325 647.109 304.139C647.109 307.953 644.581 310.328 640.103 310.328H635.408V315.942H633.386V298.094H640.103V298.166ZM635.408 308.457H640.031C643.281 308.457 645.087 307.018 645.087 304.283C645.087 301.548 643.209 300.181 640.031 300.181H635.408V308.457Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.551 307.09C667.551 312.128 663.433 316.086 658.161 316.086C652.888 316.086 648.771 312.056 648.771 307.09C648.771 302.124 652.888 298.094 658.161 298.094C663.433 298.094 667.551 302.052 667.551 307.09ZM650.865 307.09C650.865 311.048 654.188 314.143 658.161 314.143C662.133 314.143 665.456 310.976 665.456 307.09C665.456 303.204 662.206 300.037 658.161 300.037C654.116 300.037 650.865 303.132 650.865 307.09Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.252 310.328C678.891 310.328 678.457 310.328 678.024 310.328H673.257V315.942H671.234V298.094H678.024C682.502 298.094 685.103 300.253 685.103 304.067C685.103 307.018 683.658 309.033 681.058 309.825L685.247 315.87H682.936L679.252 310.185V310.328ZM678.096 308.457C681.347 308.457 683.152 307.018 683.152 304.283C683.152 301.548 681.347 300.181 678.096 300.181H673.329V308.457H678.096Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.215 300.178V316.083H693.192V300.178H687.342V298.234H701.065V300.178H695.215Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.689 308.672C718.689 313.278 715.872 316.084 711.177 316.084C706.483 316.084 703.666 313.278 703.666 308.672V298.164H705.688V308.672C705.688 312.126 707.783 314.141 711.177 314.141C714.572 314.141 716.595 312.126 716.595 308.672V298.164H718.617V308.672H718.689Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.53 316.012L725.768 301.691V316.012H723.746V298.164H725.84L736.603 312.486V298.164H738.625V316.012H736.53Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.042 316.012V298.164H746.065V316.012H744.042Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.777 298.164C763.978 298.164 767.95 301.978 767.95 307.088C767.95 312.198 763.905 316.012 758.633 316.012H751.482V298.164H758.705H758.777ZM753.577 314.069H758.777C762.75 314.069 765.856 311.118 765.856 307.088C765.856 303.058 762.678 300.107 758.705 300.107H753.577V314.069Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.862 311.549L770.84 316.083H768.673L776.69 298.234H778.785L786.803 316.083H784.563L782.541 311.549H772.79H772.862ZM777.702 300.537L773.729 309.605H781.747L777.702 300.537Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.915 298.164C802.115 298.164 806.088 301.978 806.088 307.088C806.088 312.198 802.043 316.012 796.77 316.012H789.62V298.164H796.843H796.915ZM791.714 314.069H796.915C800.888 314.069 803.993 311.118 803.993 307.088C803.993 303.058 800.815 300.107 796.843 300.107H791.714V314.069Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.866 300.179V306.009H820.895V307.952H811.866V314.069H822.268V316.012H809.772V298.164H821.906V300.107H811.794L811.866 300.179Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.508 299.747L836.641 301.691C835.052 300.611 833.102 300.179 831.73 300.179C829.418 300.179 827.901 301.043 827.901 302.554C827.901 307.16 837.941 304.713 837.941 311.19C837.941 314.141 835.341 316.084 831.441 316.084C828.84 316.084 826.24 314.933 824.579 313.35L825.518 311.55C827.179 313.134 829.49 314.069 831.441 314.069C834.041 314.069 835.63 312.99 835.63 311.334C835.63 306.656 825.59 309.175 825.59 302.77C825.59 299.963 828.046 298.164 831.802 298.164C833.897 298.164 835.991 298.812 837.508 299.819V299.747Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.36 298.164C861.561 298.164 865.533 301.978 865.533 307.088C865.533 312.198 861.488 316.012 856.216 316.012H849.065V298.164H856.288H856.36ZM851.232 314.069H856.432C860.405 314.069 863.511 311.118 863.511 307.088C863.511 303.058 860.333 300.107 856.36 300.107H851.232V314.069Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.384 300.179V306.009H880.413V307.952H871.384V314.069H881.785V316.012H869.289V298.164H881.424V300.107H871.312L871.384 300.179Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.838 316.012L895.075 301.691V316.012H893.053V298.164H895.148L905.91 312.486V298.164H907.932V316.012H905.838Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.444 300.179V306.009H924.473V307.952H915.444V314.069H925.845V316.012H913.35V298.164H925.484V300.107H915.372L915.444 300.179Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.336 307.304V313.781C942.603 315.221 940.075 316.156 937.691 316.156C932.491 316.156 928.374 312.126 928.374 307.16C928.374 302.194 932.563 298.164 937.836 298.164C940.291 298.164 942.747 299.1 944.409 300.611L943.253 302.122C941.808 300.827 939.858 300.035 937.836 300.035C933.719 300.035 930.468 303.202 930.468 307.088C930.468 310.975 933.791 314.141 937.836 314.141C939.425 314.141 941.158 313.565 942.531 312.63V307.232H944.336V307.304Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.367 307.09C966.367 312.128 962.25 316.086 956.977 316.086C951.704 316.086 947.587 312.056 947.587 307.09C947.587 302.124 951.704 298.094 956.977 298.094C962.25 298.094 966.367 302.052 966.367 307.09ZM949.682 307.09C949.682 311.048 953.004 314.143 956.977 314.143C960.949 314.143 964.272 310.976 964.272 307.09C964.272 303.204 961.022 300.037 956.977 300.037C952.932 300.037 949.682 303.132 949.682 307.09Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.846 300.755L982.618 302.338C981.246 300.971 979.296 300.107 977.345 300.107C973.301 300.107 970.05 303.202 970.05 307.16C970.05 311.118 973.301 314.213 977.345 314.213C979.296 314.213 981.246 313.421 982.618 312.054L983.846 313.421C982.113 315.077 979.657 316.156 977.201 316.156C972.073 316.156 967.956 312.126 967.956 307.088C967.956 302.05 972.073 298.164 977.273 298.164C979.729 298.164 982.113 299.172 983.846 300.755Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.602 316.012V298.164H989.625V316.012H987.602Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.09 307.09C1012.09 312.128 1007.97 316.086 1002.7 316.086C997.426 316.086 993.309 312.056 993.309 307.09C993.309 302.124 997.426 298.094 1002.7 298.094C1007.97 298.094 1012.09 302.052 1012.09 307.09ZM995.476 307.09C995.476 311.048 998.798 314.143 1002.77 314.143C1006.74 314.143 1010.07 310.976 1010.07 307.09C1010.07 303.204 1006.82 300.037 1002.77 300.037C998.726 300.037 995.476 303.132 995.476 307.09Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.477 119.671L326.48 104.702C326.119 102.327 326.552 99.7361 327.853 97.505C330.958 92.1074 337.893 90.2362 343.31 93.4028C348.655 96.4975 350.533 103.335 347.427 108.732C344.321 114.13 337.387 116.001 331.97 112.834C331.536 112.619 331.103 112.331 330.669 111.971L304.667 126.94C304.956 128.236 305.172 129.531 305.172 130.899C305.172 139.535 298.094 146.516 289.426 146.516C280.759 146.516 273.752 139.535 273.752 130.899C273.752 122.262 280.759 115.209 289.426 115.209C293.76 115.209 297.588 116.937 300.477 119.671Z",
    fill: "url(#paint0_radial_6110_85462)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.944 286.85C348.944 293.04 343.888 298.078 337.676 298.078C331.464 298.078 326.336 293.04 326.336 286.85C326.336 286.275 326.408 285.771 326.48 285.267L300.477 270.226C297.588 273.032 293.76 274.76 289.426 274.76C280.759 274.76 273.752 267.707 273.752 259.07C273.752 250.434 280.759 243.453 289.426 243.453C298.094 243.453 305.172 250.434 305.172 259.07C305.172 260.438 304.956 261.733 304.667 263.029L330.669 277.998C332.62 276.487 335.003 275.551 337.676 275.551C343.888 275.551 348.944 280.589 348.944 286.85Z",
    fill: "url(#paint1_radial_6110_85462)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.788 87.6459L278.303 68.3582C277.653 63.9681 279.747 59.3621 283.792 57.0591C289.209 53.8924 296.144 55.7636 299.249 61.1613C302.355 66.559 300.477 73.396 295.132 76.4907C291.015 78.8657 286.031 78.3619 282.492 75.6271L249.049 94.9147C249.338 96.1382 249.483 97.5056 249.483 98.8011C249.483 107.437 242.477 114.49 233.809 114.49C225.141 114.49 218.135 107.437 218.135 98.8011C218.135 90.1648 225.141 83.1838 233.809 83.1838C238.071 83.1838 241.971 84.9111 244.788 87.6459Z",
    fill: "url(#paint2_radial_6110_85462)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.766 323.2C300.766 329.389 295.71 334.427 289.426 334.427C283.142 334.427 278.158 329.389 278.158 323.2C278.158 322.624 278.23 322.12 278.303 321.617L244.788 302.329C241.971 305.064 238.071 306.791 233.809 306.791C225.141 306.791 218.135 299.81 218.135 291.102C218.135 282.393 225.141 275.484 233.809 275.484C242.477 275.484 249.483 282.465 249.483 291.102C249.483 292.469 249.338 293.765 249.049 295.06L282.492 314.348C284.442 312.836 286.826 311.901 289.426 311.901C295.71 311.901 300.766 317.01 300.766 323.2Z",
    fill: "url(#paint3_radial_6110_85462)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.211 229.278C260.317 234.676 258.512 241.513 253.094 244.608C247.677 247.775 240.815 245.903 237.709 240.506C234.603 235.108 236.409 228.271 241.826 225.176C247.244 222.01 254.106 223.881 257.211 229.278Z",
    fill: "url(#paint4_radial_6110_85462)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.094 164.794C247.677 167.96 240.815 166.089 237.709 160.691C234.603 155.294 236.409 148.457 241.826 145.29C247.244 142.195 254.106 144.067 257.211 149.464C260.317 154.79 258.512 161.699 253.094 164.794Z",
    fill: "url(#paint5_radial_6110_85462)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.441 16.8971C165.335 11.4994 167.141 4.59041 172.558 1.49574C177.975 -1.59892 184.837 0.272269 187.943 5.59798C191.049 10.9957 189.243 17.9047 183.826 20.9993C178.409 24.094 171.547 22.2948 168.441 16.8971Z",
    fill: "url(#paint6_radial_6110_85462)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.518 66.7707C162.518 58.1344 169.524 51.0814 178.192 51.0814C182.453 51.0814 186.354 52.8087 189.171 55.6155L222.685 36.3278C222.035 31.8657 224.058 27.3317 228.175 24.9567C233.592 21.862 240.454 23.7332 243.56 29.0589C246.738 34.4566 244.86 41.3656 239.443 44.4603C235.326 46.8353 230.342 46.3315 226.875 43.5967L193.36 62.8843C193.721 64.1078 193.866 65.4033 193.866 66.7707C193.866 75.4069 186.859 82.4599 178.192 82.4599C169.524 82.4599 162.518 75.4069 162.518 66.7707Z",
    fill: "url(#paint7_radial_6110_85462)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.077 355.223C245.077 361.485 240.021 366.522 233.809 366.522C227.597 366.522 222.541 361.485 222.541 355.223C222.541 354.719 222.613 354.144 222.686 353.64L189.171 334.352C186.354 337.159 182.453 338.814 178.192 338.814C169.524 338.814 162.518 331.833 162.518 323.197C162.518 314.561 169.524 307.508 178.192 307.508C186.859 307.508 193.866 314.561 193.866 323.197C193.866 324.564 193.721 325.86 193.36 327.083L226.875 346.371C228.753 344.86 231.209 343.996 233.809 343.996C240.021 343.996 245.077 349.034 245.077 355.223Z",
    fill: "url(#paint8_radial_6110_85462)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.826 124.921C178.409 128.016 171.547 126.145 168.441 120.819C165.335 115.421 167.141 108.512 172.558 105.418C177.975 102.323 184.837 104.122 187.943 109.52C191.049 114.918 189.243 121.827 183.826 124.921Z",
    fill: "url(#paint9_radial_6110_85462)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.943 269.145C191.049 274.543 189.243 281.452 183.826 284.546C178.409 287.641 171.547 285.77 168.441 280.444C165.335 275.046 167.141 268.137 172.558 265.043C177.975 261.948 184.837 263.819 187.943 269.145Z",
    fill: "url(#paint10_radial_6110_85462)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.248 98.7968C138.248 107.433 131.242 114.486 122.575 114.486C113.907 114.486 106.828 107.433 106.828 98.7968C106.828 91.5999 111.74 85.5546 118.385 83.7553V45.18C114.196 43.5247 111.307 39.4224 111.307 34.7444C111.307 28.4831 116.291 23.4453 122.575 23.4453C128.859 23.4453 133.842 28.4831 133.842 34.7444C133.842 39.4224 130.881 43.5247 126.764 45.18V83.7553C133.337 85.5546 138.248 91.5999 138.248 98.7968Z",
    fill: "url(#paint11_radial_6110_85462)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.943 373.075C191.049 378.472 189.243 385.309 183.826 388.476C178.409 391.571 171.547 389.699 168.441 384.302C165.335 378.976 167.141 372.067 172.558 368.972C177.975 365.878 184.837 367.677 187.943 373.075Z",
    fill: "url(#paint12_radial_6110_85462)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.1721 240.506C95.994 235.108 97.8719 228.271 103.289 225.176C108.634 222.01 115.568 223.881 118.674 229.278C121.78 234.676 119.974 241.513 114.557 244.608C109.14 247.775 102.278 245.903 99.1721 240.506Z",
    fill: "url(#paint13_radial_6110_85462)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.764 306.215V344.791C129.003 345.726 131.025 347.309 132.326 349.612C135.431 355.01 133.554 361.847 128.208 365.014C122.791 368.109 115.929 366.237 112.751 360.84C109.645 355.514 111.523 348.605 116.941 345.51C117.374 345.222 117.88 345.006 118.313 344.791V306.215C111.74 304.416 106.828 298.299 106.828 291.102C106.828 282.465 113.907 275.484 122.575 275.484C131.242 275.484 138.248 282.465 138.248 291.102C138.248 298.299 133.409 304.416 126.764 306.215Z",
    fill: "url(#paint14_radial_6110_85462)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.1721 160.691C95.994 155.294 97.8719 148.457 103.289 145.29C108.634 142.195 115.568 144.067 118.674 149.464C121.78 154.79 119.974 161.699 114.557 164.794C109.14 167.96 102.278 166.089 99.1721 160.691Z",
    fill: "url(#paint15_radial_6110_85462)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.6313 130.898C82.6313 139.535 75.5527 146.516 66.8851 146.516C58.2175 146.516 51.2112 139.535 51.2112 130.898C51.2112 123.702 56.0506 117.656 62.6958 115.785V77.2095C58.5787 75.5543 55.6172 71.524 55.6172 66.774C55.6172 60.5847 60.6733 55.5469 66.8851 55.5469C73.0969 55.5469 78.153 60.5847 78.153 66.774C78.153 71.524 75.2638 75.5543 71.1467 77.2095V115.785C77.7196 117.656 82.6313 123.702 82.6313 130.898Z",
    fill: "url(#paint16_radial_6110_85462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7078 114.345C24.9309 114.345 29.9757 109.318 29.9757 103.118C29.9757 96.9172 24.9309 91.8906 18.7078 91.8906C12.4848 91.8906 7.43994 96.9172 7.43994 103.118C7.43994 109.318 12.4848 114.345 18.7078 114.345Z",
    fill: "url(#paint17_radial_6110_85462)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0745 274.184V312.759C73.3858 313.623 75.336 315.278 76.7084 317.581C79.8143 322.907 77.9363 329.816 72.5191 332.911C67.174 336.005 60.2399 334.206 57.134 328.808C54.0282 323.411 55.9061 316.574 61.2512 313.407C61.7568 313.191 62.1902 312.903 62.6958 312.759V274.184C56.0506 272.313 51.2112 266.267 51.2112 259.07C51.2112 250.434 58.2175 243.453 66.8851 243.453C75.5527 243.453 82.6313 250.434 82.6313 259.07C82.6313 266.267 77.7196 272.313 71.0745 274.184Z",
    fill: "url(#paint18_radial_6110_85462)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5312 292.465C25.3531 297.863 18.4912 299.662 13.074 296.567C7.65673 293.472 5.85098 286.563 8.95687 281.238C12.0628 275.84 18.9969 273.969 24.3419 277.064C29.7591 280.23 31.6371 287.067 28.5312 292.465Z",
    fill: "url(#paint19_radial_6110_85462)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.6313 194.95C82.6313 203.658 75.5528 210.639 66.8852 210.639C62.6236 210.639 58.7232 208.911 55.9062 206.177L22.4637 225.464C22.7526 227.839 22.4637 230.358 21.0191 232.661C17.9132 238.059 11.0513 239.858 5.63405 236.764C0.216787 233.669 -1.58897 226.76 1.51693 221.434C4.62282 216.036 11.4847 214.165 16.9019 217.26C17.4076 217.548 17.8409 217.836 18.2743 218.195L51.7169 198.908C51.4279 197.612 51.2112 196.317 51.2112 194.95C51.2112 193.654 51.4279 192.287 51.7169 191.063L18.2021 171.775C14.735 174.51 9.75116 175.014 5.63405 172.639C0.216787 169.544 -1.58897 162.707 1.51693 157.31C4.62282 151.912 11.4847 150.041 16.9019 153.207C21.0191 155.511 23.0415 160.117 22.4637 164.507L55.9062 183.794C58.7232 181.059 62.6236 179.332 66.8852 179.332C75.5528 179.332 82.6313 186.313 82.6313 194.95Z",
    fill: "url(#paint20_radial_6110_85462)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6110_85462",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.709 208.481) scale(170.68 170.063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_6110_85462",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.709 208.476) scale(170.68 170.063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_6110_85462",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.709 208.482) scale(170.68 170.063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_6110_85462",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.709 208.481) scale(170.68 170.063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_6110_85462",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.709 208.479) scale(170.68 170.063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_6110_85462",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.709 208.479) scale(170.68 170.063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_6110_85462",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.709 208.479) scale(170.68 170.063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_6110_85462",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.709 208.478) scale(170.68 170.063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_6110_85462",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.709 208.478) scale(170.68 170.063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_6110_85462",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.709 3.58156) scale(170.68 170.063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_6110_85462",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.709 3.57957) scale(170.68 170.063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_6110_85462",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.709 208.478) scale(170.68 170.063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_6110_85462",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.709 208.481) scale(170.68 170.063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_6110_85462",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.709 208.479) scale(170.68 170.063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_6110_85462",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.709 208.481) scale(170.68 170.063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_6110_85462",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.709 208.479) scale(170.68 170.063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_6110_85462",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.709 208.481) scale(170.68 170.063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_6110_85462",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.709 208.48) scale(170.68 170.063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_6110_85462",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.709 208.476) scale(170.68 170.063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_6110_85462",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.709 208.477) scale(170.68 170.063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_6110_85462",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.709 208.48) scale(170.68 170.063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6110_85462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1017,
    height: 390,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaintraLogo);
export default __webpack_public_path__ + "static/media/Caintra_Logo.3c29575ab5bca48074b2f04f18a122ab.svg";
export { ForwardRef as ReactComponent };